// Copyright Materialize, Inc. and contributors. All rights reserved.
//
// Use of this software is governed by the Business Source License
// included in the LICENSE file.
//
// As of the Change Date specified in that file, in accordance with
// the Business Source License, use of this software will be governed
// by the Apache License, Version 2.0.

import { Icon, IconProps } from "@chakra-ui/react";
import React from "react";

const ConfluentLogoIcon = (props: IconProps) => {
  return (
    <Icon
      width="32"
      height="32"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_1915_17789)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.9216 16.8931C23.7402 16.8186 24.5588 16.8186 25.3774 16.7442V16.1489C24.5588 16.0745 23.7402 16.0745 22.9216 16L20.4658 15.9256C19.0518 15.8512 17.5634 15.8512 16.1495 15.8512C16.1495 14.4372 16.1495 12.9489 16.0751 11.5349L16.0006 9.07911C15.9262 8.2605 15.9262 7.4419 15.8518 6.62329H15.182C15.1076 7.4419 15.1076 8.2605 15.0332 9.07911L14.9588 11.5349C14.9588 12.2047 14.9588 12.8745 14.9588 13.5442C14.6611 12.9489 14.4378 12.2791 14.1402 11.6838L13.0983 9.4512C12.7262 8.70701 12.4285 7.96283 12.0565 7.21864L11.4611 7.4419C11.7588 8.2605 11.982 9.00469 12.2797 9.74887L13.1727 12.0558C13.396 12.7256 13.6937 13.321 13.9169 13.9907C13.396 13.5442 12.9495 13.0233 12.4285 12.5768L10.6425 10.8652C10.0471 10.3442 9.4518 9.74887 8.78203 9.22794L8.2611 9.74887C8.78203 10.3442 9.37738 10.9396 9.89831 11.6093L11.6099 13.3954C12.0565 13.9163 12.5774 14.3628 13.0239 14.8838C12.4285 14.6605 11.7588 14.3628 11.089 14.1396L8.78203 13.2465C8.03785 12.9489 7.21924 12.6512 6.47505 12.4279L6.17738 13.0977C6.92157 13.4698 7.66575 13.7675 8.40994 14.1396L10.6425 15.1814C11.2378 15.4791 11.9076 15.7024 12.503 16C11.8332 16 11.1634 16 10.4937 16L8.03785 16.0745C7.21924 16.1489 6.40064 16.1489 5.58203 16.2233V16.8931C6.40064 16.9675 7.21924 16.9675 8.03785 17.0419L10.4937 17.1163C11.982 17.1907 13.396 17.1907 14.8099 17.1907C14.8099 18.6047 14.8099 20.0931 14.8844 21.507L14.9588 23.9628C15.0332 24.7814 15.0332 25.6 15.1076 26.4186H15.703C15.7774 25.6 15.7774 24.7814 15.8518 23.9628L15.9262 21.507C15.9262 20.8372 15.9262 20.0931 16.0006 19.4233C16.2983 20.0931 16.5216 20.6884 16.8192 21.3582L17.8611 23.5907C18.2332 24.3349 18.5309 25.0791 18.903 25.8233L19.4983 25.6C19.2751 24.7814 18.9774 24.0372 18.6797 23.2931L17.9355 20.8372C17.7123 20.1675 17.4146 19.5721 17.1913 18.9024C17.7123 19.4233 18.1588 19.8698 18.6797 20.3163L20.4658 22.0279C21.0611 22.5489 21.6565 23.1442 22.3262 23.6652L22.7727 23.2186C22.2518 22.6233 21.6565 22.0279 21.1355 21.3582L19.4239 19.5721C18.9774 19.0512 18.4565 18.5303 18.0099 18.0838C18.6797 18.307 19.2751 18.6047 19.9448 18.8279L22.2518 19.721C22.996 20.0186 23.8146 20.3163 24.5588 20.5396L24.782 19.9442C24.0378 19.5721 23.2937 19.2 22.5495 18.9024L20.3169 17.8605C19.6471 17.5628 19.0518 17.2652 18.382 17.0419C19.0518 17.0419 19.796 17.0419 20.4658 16.9675L22.9216 16.8931Z"
          fill="#173361"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 32C7.14419 32 0 24.8558 0 16C0 7.14419 7.14419 0 16 0C24.8558 0 32 7.14419 32 16C32 24.8558 24.8558 32 16 32ZM16 1.48837C8.03721 1.48837 1.48837 8.03721 1.48837 16C1.48837 23.9628 8.03721 30.5116 16 30.5116C23.9628 30.5116 30.5116 23.9628 30.5116 16C30.5116 8.03721 23.9628 1.48837 16 1.48837Z"
          fill="#173361"
        />
      </g>
      <defs>
        <clipPath id="clip0_1915_17789">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </Icon>
  );
};

export default ConfluentLogoIcon;
